import React, { Component } from 'react';

class animationSlogan extends Component {
    constructor(props) {
        super(props);
        this.state = {
            bigMessageTextArray: ["acne","dryness","redness","mature skin","oiliness"],
            bigMessageShowText: 'acne',
            bigMessageShowindex: 0,
        }
    }
    componentDidMount() {
        this.animationFontChange()
    }

    animationFontChange() {
        var textArry = this.state.bigMessageTextArray;
        var showindex = this.state.bigMessageShowindex > 4 ? 0 : this.state.bigMessageShowindex
        setTimeout(() => {
            this.setState({
                bigMessageShowText:textArry[showindex],
                bigMessageShowindex: showindex+1
            })
            this.animationFontChange()
        }, 800);
    }

    render() {
        return (
            <span className="big-message-span">{this.state.bigMessageShowText}</span>
        );
    }
}


export default animationSlogan;



// WEBPACK FOOTER //
// ./src/views/home/animationSlogan.js